import React, {Component} from 'react';
import { findDOMNode } from 'react-dom'
import {Box} from 'reactjs-admin-lte'
import {Modal,Button,ButtonToolbar,DropdownButton,SplitButton,MenuItem,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl,Tabs,Tab,Panel} from 'react-bootstrap'
import Select from 'react-select';
import FontAwsome from 'react-fontawesome'
import { Checkbox, Radio } from 'react-icheck';
import {  scroller } from 'react-scroll'
import {toast} from 'react-toastify';
import {SubscribeStore} from '../../stores/SubscribeStore';
import WorkdocStore from '../../stores/WorkdocStore';
import './WorkDoc.css';
import IframeModal from '../../component/element/IframeModal'
import Lightbox from 'react-images-extended';
import PDF from '../../asset/img/pdf-512.png';

var NotificationSystem = require('react-notification-system');
const DEPARTMENT_KEY = ['stock','photo','withdrawal','finance','reception','branch_manager']
const keyStr = "ABCDEFGHIJKLMNOP" +
               "QRSTUVWXYZabcdef" +
               "ghijklmnopqrstuv" +
               "wxyz0123456789+/" +
               "="

const msgTemplate  = {
	title: 'Example Confirm Notification',
	content: 'ดูผลลัพธ์ได้ที่ https://putsreq.com/VnxVg9kePlts5MSGdDIZ/inspect',
	content_type :'text',
	message_type: 'buttons',
	message_buttons: [
		{
			text: 'รับทราบ',
			style: 'primary',
			action: {
				type: 'js',
				data: {
					confirm: true,					
				},
			},
		},
		{
			text: 'เปิดดู',
			style: 'success',
			action: {
				type: 'open_work',
				data: {
					confirm: true,
					work_no:''					
				},
			},
		},
	],
	options: {
		position: toast.POSITION.BOTTOM_RIGHT,
		closeOnClick: true,
		autoClose:false,
	},
}

const MSG_PREFIX_CAT = 'msg/msg_'
class WorkDocMessage extends Component {

  constructor(...args){
    super(...args)
    this.state = {images:[],currentImage:0,lightboxIsOpen:false,data:{messagelist:[],userlist:[],sender_id:'',sender_name:'',departmentlist:[],userList:[]},loading:true,messageText:'',showDepart:false,checkedDepart:[],checkedDepartAll:false,checkedPerson:[],checkedPersonAll:false,dataImg:{files:[]},_rand:'',imgPre:false,showAllImg:false}}
	
  componentDidMount() {
  	this._notificationSystem = this.refs.notificationSystem;
    this.loadData()		
  }

  loadData() {
  		WorkdocStore.loadWorkdocMessages(this.props.workNo,(result)=> {
			let data = result.data
			let userlist =[]
			data.messagelist.reduce((result,item)=>{
				var found = userlist.find(function(element) {return element.sender_name === item.sender_name;});
				if(found===undefined){
					userlist.push({sender_name:item.sender_name,avatar_color:item.avatar_color})
				}
				return result
			},[])
			data.userlist = userlist
			let checkedDepart = new Array(data.departmentlist.length).fill(false)
			let checkedPerson = new Array(data.userList.length).fill(false)
			this.setState({data:result.data,loading:false,checkedDepart:checkedDepart,checkedPerson:checkedPerson})
			
			setTimeout(()=>{
				this.scrollTo(data.messagelist.length-1)
			},1000)
			
			},()=>{

		})
  }		

  scrollTo(msgInd) {
			scroller.scrollTo('scroll-to-element-'+msgInd, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        containerId: 'scroll-container'
      })
  }

  getDate(added_date) {
  	let year = added_date.substring(0, 4)
  	year = parseInt(year) + 543
  	let month = added_date.substring(5, 7)
  	let day = added_date.substring(8, 10)
  	let mText = ""
  	if (month=="01") {
  		mText = "ม.ค."
  	} else if (month=="02") {
  		mText = "ก.พ."
  	} else if (month=="03") {
  		mText = "มี.ค."
  	} else if (month=="04") {
  		mText = "เม.ย."
  	} else if (month=="05") {
  		mText = "พ.ค."
  	} else if (month=="06") {
  		mText = "มิ.ย."
  	} else if (month=="07") {
  		mText = "ก.ค."
  	} else if (month=="08") {
  		mText = "ส.ค."
  	} else if (month=="09") {
  		mText = "ก.ย."
  	} else if (month=="10") {
  		mText = "ต.ค."
  	} else if (month=="11") {
  		mText = "พ.ย."
  	} else if (month=="12") {
  		mText = "ธ.ค."
  	}
  	return day+" "+mText+" "+year
  }

  getDateBgColor(week_flag,today_flag) {
  	if (today_flag == 1)
        return "bg-green div-time-label";
    else if (week_flag == 1)
        return "bg-yellow div-time-label";
    else
        return "bg-red div-time-label";		
	}
	
	isMessageEmpty(message){
		if(message.length==0){
			return true
		}else{
			return false
		}
	}

  _sendMessage(message,departmentList,completeFunc) {
  	let {messageText,data,checkedDepartAll,checkedDepart,_rand} = this.state
  	let messageObj = {sender_id:data.sender_id,sender_name:data.sender_name,avatar_color:data.avatar_color,message:message,is_owner:true}
		let postData = {work_no:this.props.workNo,data:messageObj}
		messageObj = Object.assign(messageObj,{added_date:'กำลังส่ง...',bf_msg_id:''})
		data.messagelist.push(messageObj)
		this.setState({data:data,messageText:''})
		
		setTimeout(()=>{
			this.scrollTo(data.messagelist.length-1)
		},500)
		
				
		WorkdocStore.saveWorkdocMessages(postData,(result)=> {
			if(result.status==='OK'){
				this.sendRealtimeNoti(departmentList.map((item,index)=>{
					return this.getRealtimeNotiMsg('group/',item,postData)
				}))
				
				this.sendRealtimeNoti(message.userList.map((item,index)=>{
					let userid = item.userid.replace("@", "_");
					return this.getRealtimeNotiMsg('user/',userid,postData)
				}))
				messageObj =  data.messagelist[data.messagelist.length-1]
				messageObj.added_date = 'ขณะนี้';
				messageObj.bf_msg_id = result.id
				data.messagelist[data.messagelist.length-1] = messageObj

				
				this._notificationSystem.addNotification({
					title: 'แจ้งเตือน',
					message: 'ทำการบันทึกรายละเอียด ' + this.props.workNo + ' เรียบร้อย',
					level: 'info',
					position: 'tc',        
				});
				this.setState({data:data,showDepart:false,checkedDepart:new Array(data.departmentlist.length).fill(false),checkedDepartAll:false,checkedPerson:new Array(data.userList.length).fill(false),checkedPersonAll:false})

				if(completeFunc!==undefined){
					completeFunc()
				}
				
			}
		},()=>{
			  this._notificationSystem.addNotification({
		        title: 'แจ้งเตือน',
		        message: 'ไม่สามารถบันทึกรายละเอียด ' + this.props.workNo + ' ได้',
		        level: 'error',
		        position: 'tc',        
		      });
		      this.setState({showDepart:false,checkedDepart:new Array(data.departmentlist.length).fill(false),checkedDepartAll:false,checkedPerson:new Array(data.userList.length).fill(false),checkedPersonAll:false})
		})
  }	

  sendMessage(){
		let {messageText,data,checkedDepartAll,checkedDepart,dataImg,_rand,checkedPersonAll,checkedPerson} = this.state
		if(this.isMessageEmpty(messageText)&&dataImg.files.length===0){
			this._notificationSystem.addNotification({
		        title: 'แจ้งเตือน',
		        message: 'ไม่สามารถส่งข้อความว่างได้',
		        level: 'error',
		        position: 'tc',        
			});
			return false
		} 

		let departmentList = []
		if (checkedDepartAll) {
			departmentList = data.departmentlist.map((item,index)=>{
				return item.department_id
			})
		} else {
			checkedDepart.forEach(function(item,index) {
				if (item)
					departmentList.push(data.departmentlist[index].department_id)
			})
		}
		
		let userList = []
		if (checkedPersonAll) {
			userList = data.userList.map((item,index)=>{
				return {userid:item.userid}
			})
		} else {
			checkedPerson.forEach(function(item,index) {
				if (item)
					userList.push({userid:data.userList[index].userid})
			})
		}

		if (dataImg.files.length>0) {
				let imageUrl = []
				let thumbUrl = []
				dataImg.files.forEach(function(item,index) {
					imageUrl.push(item.url)
					thumbUrl.push(item.thumbnailUrl)
				})
				let imgs = {type:'image',text:'ข้อความแบบรูปภาพ',departmentList:departmentList,userList:userList,imageUrl:imageUrl,thumbUrl:thumbUrl,catId:MSG_PREFIX_CAT+_rand}
				this._sendMessage(imgs,departmentList,()=>{
					this.setState({_rand:'',dataImg:{files:[]}})
				})			
		}	else{
			let message = {type:'text',text:messageText,departmentList:departmentList,userList:userList}
			this._sendMessage(message,departmentList)
		}
	}

	getRealtimeNotiMsg(prefixGroup,groupId,postData){
		let msg =  JSON.parse(JSON.stringify(msgTemplate))
		msg['title'] = 'เลขรับแจ้ง '+postData.work_no
		if(postData.data.message.type==='text'){
			msg['content'] = postData.data.message.text
			msg['content_type'] = 'text'
		}else{
			msg['content'] = postData.data.message.thumbUrl[0]
			msg['content_type'] = 'image'
		}

		msg['message_buttons'][1]['action']['data']['work_no'] = postData.work_no
		let send_data = {channel_id:prefixGroup+groupId,data:msg}
		return send_data
	}	
	
	sendRealtimeNoti(msgList){
		this.realtime = new SubscribeStore();
		this.realtime.connect('', () => {

			msgList.forEach((send_data,index)=>{
				this.realtime.sendChannel(send_data.channel_id,send_data);
				//console.log('sending...', send_data,JSON.stringify(send_data));
			})
			
			
			this.realtime.disconnect();

			this.setState({sending: false});
		});
	}

  onDepartClick(e) {
  	this.sendMessage(false)
  }

  onSendClick(){
  	this.setState({showDepart:true})
	}

  onSearchKeyPress(target) {
    if (target.charCode == 13) {
			this.setState({showDepart:true})
		}
  }

  onTextChange(e){
		this.setState({messageText:e.target.value})
  }

  getFirstChar(name){
	  return name[0]+name[1]
  }

  onDepartChange(key,e) {
  	let {checkedDepartAll,checkedDepart} = this.state
  	if (key=='all') {
  		if (checkedDepartAll) {
  			checkedDepartAll = false
  			let newChecked = []
  			checkedDepart.forEach(function(item,index) {
  				newChecked.push(false)
  			})
  			this.setState({checkedDepartAll:checkedDepartAll,checkedDepart:newChecked})
  		} else {
  			checkedDepartAll = true
  			let newChecked = []
  			checkedDepart.forEach(function(item,index) {
  				newChecked.push(true)
  			})
  			this.setState({checkedDepartAll:checkedDepartAll,checkedDepart:newChecked})
  		}
  	} else {
  		if (checkedDepart[key]) {
  			checkedDepart[key] = false
  			this.setState({checkedDepartAll:false})
  		} else {
  			checkedDepart[key] = true
  			let checkedAllTrue = true
  			checkedDepart.forEach(function(item,index) {
  				if (!item)
  				  checkedAllTrue = false
  			})

  			if (!checkedAllTrue) {
  			  this.setState({checkedDepartAll:false}) 
  			} else {
  			  this.setState({checkedDepartAll:true}) 
  			}
  		}
  		this.setState({checkedDepart:checkedDepart})
  	}
	}
	
	onPersonChange(key,e) {
  	let {checkedPersonAll,checkedPerson} = this.state
  	if (key=='all') {
  		if (checkedPersonAll) {
  			checkedPersonAll = false
  			let newChecked = []
  			checkedPerson.forEach(function(item,index) {
  				newChecked.push(false)
  			})
  			this.setState({checkedPersonAll:checkedPersonAll,checkedPerson:newChecked})
  		} else {
  			checkedPersonAll = true
  			let newChecked = []
  			checkedPerson.forEach(function(item,index) {
  				newChecked.push(true)
  			})
  			this.setState({checkedPersonAll:checkedPersonAll,checkedPerson:newChecked})
  		}
  	} else {
  		if (checkedPerson[key]) {
  			checkedPerson[key] = false
  			this.setState({checkedPersonAll:false})
  		} else {
  			checkedPerson[key] = true
  			let checkedAllTrue = true
  			checkedPerson.forEach(function(item,index) {
  				if (!item)
  				  checkedAllTrue = false
  			})

  			if (!checkedAllTrue) {
  			  this.setState({checkedPersonAll:false}) 
  			} else {
  			  this.setState({checkedPersonAll:true}) 
  			}
  		}
  		this.setState({checkedPerson:checkedPerson})
  	}
  }

  onSelectDDmessageTool(e) {
  	if (e==='1') {
  		this.setState({showAllImg:true})
  	}
  }

  getGenKey() {
  	let text = '';
	let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"

	for (var i = 0; i < 5; i++)
	  text += possible.charAt(Math.floor(Math.random() * possible.length))

	return text;
  }

  onUploadClick(e) {
  	let {dataImg,_rand} = this.state
    let url = ''
    let cat = this.getGenKey()
    if (dataImg.files.length>0&&dataImg.files!==undefined) {
    	cat = _rand
    } else {
    	this.setState({_rand:cat})
    }

    if (process.env.NODE_ENV == "development") {
      url = 'https://demo2.bigfix.co/korat/fup/?wo='+this.props.workNo+'&cat='+MSG_PREFIX_CAT+cat
    } else {
      url = './fup/?wo='+this.props.workNo+'&cat='+MSG_PREFIX_CAT+cat
    }
    this.refs.iframeUpload.loadUrl(url)
  }

  onUpImgHide(e) {
  	let {dataImg,_rand} = this.state

    WorkdocStore.loadFup(this.props.workNo,MSG_PREFIX_CAT+_rand,(result)=> {
      this.setState({dataImg:result.data,imgPre:true})
    })
  }

  renderImgBeforeSend() {
  	let {imgPre,dataImg} = this.state
  	return(
  		<div className='box-slide-img-before-send' style={{display:(imgPre?'':'none')}}>
	  		<ul className='slide-img-before-send'>
		  		{this.renderImgZone(dataImg)}
		  	</ul>	
	  	</div>	
  	)
  }

  renderImgZone(dataImg) {
  	if (dataImg.files.length===0||dataImg.files===undefined) {
  	  return(<li></li>)
  	} else {
  	  return(
  	  	dataImg.files.map((item,index)=> {
  	  	  let type = item.name.substring(item.name.length-3)	
  	  	  let thumbnailUrl = ''
  	  	  if (type=='pdf')
  	  	  	thumbnailUrl = PDF
  	  	  else
  	  	  	thumbnailUrl = item.thumbnailUrl
  	  	  return(
  	  	  	<li key={index}>
  	  	  	  <div style={{position:'relative'}}>
  	  	  	    <div style={{borderRadius:'8px',backgroundImage:'url('+thumbnailUrl+')',backgroundPosition:'50% 50%',backgroundRepeat:'no-repeat',height:'54px',width:'54px',backgroundSize:'cover'}}></div>
  	  	  	    <FontAwsome className='_339l _61ns _5upp _42ft' name='check' style={{color:'#5cb85c'}} />
  	  	  	  </div>  
  	  	  	</li>
  	  	  )
  	  	})
  	  )
  	}
  }

  renderDirectChatMessage(item,index){
	 
		return (
			<div key={index} className={"direct-chat-msg "+(item.is_owner?"right":"")+(" scroll-to-element-"+index)}>
				<div className="direct-chat-info clearfix">
					<span className={"direct-chat-name "+(item.is_owner?"pull-right":"pull-left")}>{item.sender_name}</span>
					
				</div>
				<div className={"direct-chat-img text-center "+item.avatar_color} style={{lineHeight:'40px'}}><span>{this.getFirstChar(item.sender_name)}</span></div>
				
				<div className={"direct-chat-text "+(item.is_owner?"pull-right":"")} style={{display:'inline-block',marginLeft:'10px',marginRight:'10px'}}>
					{item.message.text}
				</div>
				<div className={"direct-chat-info clearfix "+(item.is_owner?"pull-right":"")} style={{display:'inline-block'}}>
					
					<span className={"direct-chat-timestamp "}>{item.added_date}</span>
				</div>
			</div>
		)
	
  }

  renderUserGroupHeader(){
		let {messagelist,userlist} = this.state.data
		return (
			<div className='pull-right'>
				{userlist.map((item,index)=>(
					<div key={index} className={"direct-chat-img text-center "+item.avatar_color} style={{lineHeight:'40px',marginLeft:'10px'}}><span>{this.getFirstChar(item.sender_name)}</span></div>
				))}
			</div>
		)
  }

  onImgPreviewClick(imageUrl,e) {
  	let {data,images} = this.state
  	let allImg = []
  	data.messagelist.forEach(function(item,index) {
  		if (item.message.type=='image') {
  			item.message.imageUrl.forEach(function(_item,_index) {
  				allImg.push(_item)
  			})
  		}
  	})
  	
  	let checkCurImg = 0
  	allImg.forEach(function(item,index) { 
  	  if (imageUrl===item)
  	  	checkCurImg = index

  	  let type = item.substring(item.length-3)
  	  let url = item
  	  if (type=='pdf')
  	    url = PDF

  	  images.push({
  	    src: url,
				thumbnail: url,
				srcset: [url],
				caption: ''
			})	
  	})

    this.setState({currentImage:checkCurImg,lightboxIsOpen:true,images:images})
  }

  onClickImage(e) {
  	let {data} = this.state
  	let allImg = []
  	data.messagelist.forEach(function(item,index) {
  		if (item.message.type=='image') {
  			item.message.thumbUrl.forEach(function(_item,_index) {
  				allImg.push(_item)
  			})
  		}
  	})

  	if (this.state.currentImage === 0) {
      this.onClickNext()
    } else if (this.state.currentImage === allImg.length-1) {
      this.onClickPrevious()
    }
  }

  onClickNext() {
    this.setState({currentImage:this.state.currentImage + 1})
  }

  onClickPrevious() {
    this.setState({currentImage:this.state.currentImage - 1})
  }

  onCloseLightbox(e) {
  	this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
      images:[]
    });
  }

  newTabPdfClick(url) {
    // if (process.env.NODE_ENV == "development") {
    //   url  = ''
    // } else{
    //   url = ''
    // }
    this.refs.iframe.loadUrl(url) 
  }

  encode64(input) {
     input = escape(input);
     var output = "";
     var chr1, chr2, chr3 = "";
     var enc1, enc2, enc3, enc4 = "";
     var i = 0;

     do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
           enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
           enc4 = 64;
        }

        output = output +
           keyStr.charAt(enc1) +
           keyStr.charAt(enc2) +
           keyStr.charAt(enc3) +
           keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
     } while (i < input.length);

     return output;
  }

  renderChatImgZone(items,indexs) {
  	return(
  	  items.message.thumbUrl.map((item,index) => {
  	  	let type = items.message.imageUrl[index].substring(items.message.imageUrl[index].length-3)
	  	let imageUrl = ''
	  	let thumbUrl = ''
	  	if (type=='pdf') {
	  		imageUrl = items.message.imageUrl[index]
	  		thumbUrl = PDF
	  	} else {
	  		imageUrl = items.message.imageUrl[index]
	  		thumbUrl = item
	  	}

	  	let posName = parseInt(items.message.imageUrl[index].indexOf('msg_'))+parseInt(10)
	  	let fileName = items.message.imageUrl[index].substr(posName)
  		return(
		  	<td className={(items.is_owner?"pull-right":"")} key={index} onClick={type=='pdf'?this.newTabPdfClick.bind(this,imageUrl):this.onImgPreviewClick.bind(this,imageUrl)}>
  	  	  	  <div style={{position:'relative'}}>
  	  	  	    <div style={{borderRadius:'8px',backgroundImage:'url('+thumbUrl+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',height:'74px',width:'74px',backgroundSize:'cover'}}></div>
  	  	  	   	{type=='pdf'?<small className='text-center ellipsis' style={{width:'74px'}}>{decodeURIComponent(fileName)}</small>:''}
  	  	  	  </div>  
  	  	  	</td>
		)
	  })	  		
  	)
  }
  
  renderDirectChatImg(item,index) {
  	return (
			<div key={index} className={"direct-chat-msg "+(item.is_owner?"right":"")+(" scroll-to-element-"+index)}>
				<div className="direct-chat-info clearfix">
					<span className={"direct-chat-name "+(item.is_owner?"pull-right":"pull-left")}>{item.sender_name}</span>
					
				</div>
				<div className={"direct-chat-img text-center "+item.avatar_color} style={{lineHeight:'40px'}}><span>{this.getFirstChar(item.sender_name)}</span></div>
				
				<div style={{overflowX:'auto'}}>
			  		<table className='table table-img-before-send'>
			  		  <tbody>
			  		    <tr>
				  		  {this.renderChatImgZone(item,index)}
				  		</tr>  
				  	  </tbody>	  
			  		</table>
			  	</div>
				
				<div className={"direct-chat-info clearfix "+(item.is_owner?"pull-right":"")} style={{display:'inline-block'}}>
					
					<span className={"direct-chat-timestamp "}>{item.added_date}</span>
				</div>
			</div>
		)
  }

  renderBoxContent(){
	  let {messagelist} = this.state.data
	  return (
		  <div>
			  <div id="scroll-container" className="direct-chat-messages" style={{height:'569px'}}>
				{
					messagelist.map((item,index)=> {
						if (item.message.type==='image')
							return this.renderDirectChatImg(item,index)
						else 
							return this.renderDirectChatMessage(item,index)
					})
				}							
				</div>														
		  </div>
	  )
	}
	
	renderDepartment(){
		let {departmentlist} = this.state.data
		let {checkedDepart} = this.state
		return departmentlist.map((item,index)=>(
			<Col key={index} md={6}>
				<Checkbox
					onChange={this.onDepartChange.bind(this,index)}
					checked={checkedDepart[index]}
					checkboxClass="icheckbox_square-blue"
					increaseArea="20%"
					label={' '+item.name}
				>
				</Checkbox>
			</Col>
		))
	}

	renderPerson(){
		let {userList} = this.state.data
		let {checkedPerson} = this.state
		return userList.map((item,index)=>(
			<Col key={index} md={6}>
				<Checkbox
					onChange={this.onPersonChange.bind(this,index)}
					checked={checkedPerson[index]}
					checkboxClass="icheckbox_square-blue"
					increaseArea="20%"
					label={' '+item.name}
				>
				</Checkbox>
			</Col>
		))
	}

  renderDepartmentModal() {
		let {data} = this.state
		return(
  			<Modal show={this.state.showDepart} onHide={()=>this.setState({showDepart:false})}>
          <Modal.Header closeButton>
            <Modal.Title>เลือกแผนกและบุคคล</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
							<div className="panel panel-default">
								<div className="panel-heading"><FontAwsome name='users' />&nbsp;เลือกแผนก</div>
								<div className="panel-body">
									<Row>
										<Col md={12}>
											<Checkbox
												onChange={this.onDepartChange.bind(this,'all')}
												checked={this.state.checkedDepartAll}
												checkboxClass="icheckbox_square-blue"
												increaseArea="20%"
												label=" เลือกทั้งหมด"
											>
											</Checkbox>
										</Col>
									</Row>
									<Row>
										{this.renderDepartment()}
									</Row>
								</div>
							</div>
							<div className="panel panel-default">
								<div className="panel-heading"><FontAwsome name='user' />&nbsp;เลือกบุคคล</div>
								<div className="panel-body">
									<Row>
										<Col md={12}>
											<Checkbox
												onChange={this.onPersonChange.bind(this,'all')}
												checked={this.state.checkedPersonAll}
												checkboxClass="icheckbox_square-blue"
												increaseArea="20%"
												label=" เลือกทั้งหมด"
											>
											</Checkbox>
										</Col>
									</Row>
									<Row>
										{this.renderPerson()}
									</Row>
								</div>
							</div>	
						</div>	
          </Modal.Body>
          <Modal.Footer>
          	<Button bsStyle={'primary'} onClick={this.onDepartClick.bind(this)}><FontAwsome name='arrow-circle-right'/>&nbsp;ส่งข้อความ</Button>
            <Button onClick={()=>this.setState({showDepart:false})}><FontAwsome name='close' />&nbsp;ปิด</Button>
          </Modal.Footer>
        </Modal>
  	)
  }

  renderShowImgModal(allImg) {
  	if (allImg.length===0) {
  		return(<div className='text-center'>ไม่มีรูปภาพ</div>)
  	} else {
	  	return(
	  	  allImg.map((item,index) => {
					return(
									<div key={index} style={{display:'inline-block',padding:'0 2px 0 2px'}} onClick={this.onImgPreviewClick.bind(this,allImg[index].img)}>
										<div style={{backgroundImage:'url('+item.thumb+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',height:'104px',width:'104px',backgroundSize:'cover'}}></div>
									</div>
					)
		  	})	  		
	  	)
		}  	
  }

  renderShowAllImgModal() {
  	let {showAllImg,data} = this.state
  	let allImg = []
  	data.messagelist.forEach(function(item,index) {
  		if (item.message.type=='image') {
  			item.message.thumbUrl.forEach(function(_item,_index) {
  				allImg.push({
  				  thumb:_item,
  				  img:item.message.imageUrl[_index]
  				})
  			})
  		}
  	})
  		
  	return(
  		<Modal show={showAllImg} onHide={()=>this.setState({showAllImg:false})}>
          <Modal.Header closeButton>
            <Modal.Title>รูปภาพทั้งหมด</Modal.Title>
          </Modal.Header>
          <Modal.Body>
	          <div style={{position:'relative',paddingLeft:'2%',paddingRight:'2%'}}>
							{this.renderShowImgModal(allImg)}
						</div>           
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={()=>this.setState({showAllImg:false})}><FontAwsome name='close' />&nbsp;ปิด</Button>
          </Modal.Footer>
        </Modal>
  	)
  }

  render() {
	  let {messageText} = this.state
	  let too_title = (<div><FontAwsome name='ellipsis-h' style={{cursor:'pointer'}} /></div>)
  	return(
  		<div style={{height:'637px',maxWidth:'650px',margin:'auto'}}>
			<Box loading={this.state.loading} className='direct-chat direct-chat-primary' style={'primary'}>
				<Box.Header className='with-border'>
					<Box.Title>
						<FontAwsome name="comments-o" className="text-blue" />&nbsp;กล่องข้อความ
						<span data-toggle="tooltip" title="" className="badge bg-light-blue" data-original-title="3 New Messages"></span>
						{this.renderUserGroupHeader()}
					</Box.Title>
					<Box.Tools>
						<DropdownButton
							className='dd-message-tool'
						    bsStyle="default"
						    title={too_title}
						    noCaret
						    id="dropdown-no-caret"
						    onSelect={this.onSelectDDmessageTool.bind(this)}
						  >
						    <MenuItem eventKey="1">รูปภาพทั้งหมด</MenuItem>
						</DropdownButton>
					</Box.Tools>
				</Box.Header>
				<Box.Body>
					{this.renderBoxContent()}
				</Box.Body>	
				<Box.Footer>
					<div className="input-group">	
						<span className="input-group-btn">											
							<Button bsStyle='default' className='btn-flat' onClick={this.onUploadClick.bind(this)}><FontAwsome name='plus'/></Button>
						</span>									
						<FormControl placeholder='พิมพ์ข้อความ ...' 
						value={messageText}
						onKeyPress={this.onSearchKeyPress.bind(this)}
						onChange={this.onTextChange.bind(this)}/>
						<span className="input-group-btn">											
							<Button bsStyle='primary' className='btn-flat' onClick={this.onSendClick.bind(this)}>ส่งข้อความ <FontAwsome name='arrow-circle-right'/></Button>
						</span>
					</div>
					{this.renderImgBeforeSend()}
				</Box.Footer>						
			</Box>																		
			{this.renderDepartmentModal()}	
			<NotificationSystem ref="notificationSystem" />  
			<IframeModal 
				ref='iframeUpload' 
				title='อับโหลดรูป' 
				modal={true} 
				onUpImgHide={this.onUpImgHide.bind(this)}
			/>
			<IframeModal 
				ref='iframe' 
				title='ดาวน์โหลดไฟล์' 
			/>
			{this.renderShowAllImgModal()}
			<Lightbox
              currentImage={this.state.currentImage}
              images={this.state.images}
							isOpen={this.state.lightboxIsOpen}
							rotatable={true}
							zoomable={true}							
              onClickImage={this.onClickImage.bind(this)}
              onClickNext={this.onClickNext.bind(this)}
              onClickPrev={this.onClickPrevious.bind(this)}
              onClose={this.onCloseLightbox.bind(this)}
            />
  		</div>
  	)
  }


}

WorkDocMessage.defaultProps = {
	workNo:''
}

export default WorkDocMessage;


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocMessage.js